import { render, staticRenderFns } from "./SummaryRevenueCountry.vue?vue&type=template&id=bd389064&scoped=true&"
import script from "./SummaryRevenueCountry.vue?vue&type=script&lang=js&"
export * from "./SummaryRevenueCountry.vue?vue&type=script&lang=js&"
import style0 from "./SummaryRevenueCountry.vue?vue&type=style&index=0&id=bd389064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd389064",
  null
  
)

export default component.exports